<template>
  <section>
    <div class="recent-activities">
      <div>
        <div class="level">
          <div class="level-left">
            <h2>Activities ({{ totalRecords }})</h2>
          </div>

          <div class="level-right">
            <a @click.prevent="filterActivityData">refine</a>
          </div>
        </div>
      </div>
      <div
        class="card is-dashboard-list dashboard-activities"
        :class="{ CustomerView: !hideCustomerView }"
      >
        <b-notification :closable="false">
          <ul class="card-content">
            <div
              class="has-text-grey has-text-centered"
              v-if="records.length == 0"
            >
              <p>
                <b-icon icon="emoticon-happy-outline" size="is-large" />
              </p>
              <p>No activities to show&hellip;</p>
            </div>
            <div
              class="item-container"
              v-for="(row, index) in records"
              :key="index"
            >
              <article class="media">
                <div class="media-content">
                  <div class="content">
                    <p class="media-meta">
                      <a @click.prevent="openReport(row)" class="single-line">{{
                        row.report_id
                      }}</a>
                      <small v-if="row.isGreen" class="success">{{
                        row.report_status
                      }}</small>
                      <small v-else>{{ row.report_status }}</small
                      ><br />
                      <small v-if="row.isGreen">{{
                        row.responsible_user
                      }}</small>
                      <small v-else>{{ row.user }}</small>
                    </p>
                  </div>
                </div>
                <div class="media-right">
                  <div class="details">{{ row.update_date }}</div>
                </div>
              </article>
              <hr />
            </div>
          </ul>
          <b-loading
            :is-full-page="false"
            v-model="isLoading"
            :can-cancel="true"
          ></b-loading>
        </b-notification>
      </div>
      <refine-activity-list
        :allUsers="allUsers"
        :allCustomers="allCustomers"
        :is-active="isRefineModalActive"
        @confirm="viewConfirm"
        @cancel="closeRefineModal"
      ></refine-activity-list>
    </div>
  </section>
</template>

<script>
import "@/mixins/UtilityMixin";
import { mapGetters } from "vuex";
import { UserGroup } from "../../services/UserGroups";
import { Permission } from "../../services/Permissions";
import RefineActivityList from "./RefineActivityList.vue";
import UserDataService from "../../services/UserDataService";
import DashboardDataService from "../../services/DashboardDataService";
import UtilityMixin from "@/mixins/UtilityMixin";
// @group Dashboard
export default {
  name: "UpdatesList",
  mixins: [UtilityMixin],
  components: { RefineActivityList },
  props: {
    allUserMap: {
      type: Object,
      default() {
        return {};
      }
    },
    allUsers: {
      type: Array,
      default() {
        return [];
      }
    },
    allCustomers: {
      type: Array,
      default() {
        return [];
      }
    },
    defaultView: {
      type: Boolean
    },
    hideCustomerView: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      dashboardDataService: new DashboardDataService(),
      userDataService: new UserDataService(),
      records: [],
      userMap: this.allUserMap,
      task_count: 0,
      isRefineModalActive: false,
      enableLoadMore: false,
      scrollheight: 0,
      totalRecords: 0,
      query: "",
      nextPageCursor: "",
      isLoading: false,
      defaultVeiwChanged: false
    };
  },
  computed: {
    ...mapGetters(["userId", "userName", "userHasPermission", "userGroups"])
  },
  watch: {
    defaultView: function() {
      this.defaultVeiwChanged = true;
      if (Object.keys(this.userMap).length > 0) {
        this.fetchActivityList();
      }
    },
    allUserMap(newValue) {
      this.userMap = newValue;
      this.fetchActivityList();
    }
  },
  mounted() {
    const listElm = document.querySelectorAll(".dashboard-activities");
    listElm.forEach(element => {
      element.addEventListener("scroll", e => {
        if (
          this.enableLoadMore &&
          Math.round(listElm.scrollTop) + Math.round(listElm.clientHeight) >=
            Math.round(listElm.scrollHeight * 0.9) &&
          this.scrollheight != Math.round(listElm.scrollHeight)
        ) {
          this.scrollheight = Math.round(listElm.scrollHeight);
          this.pullNextPage();
        }
      });
    });
  },

  methods: {
    getUniqueListBy(arr, key) {
      return [...new Map(arr.map(item => [item[key], item])).values()];
    },
    pullNextPage() {
      if (this.nextPageCursor != null || this.nextPageCursor != undefined) {
        this.query = this.nextPageCursor;
        this.nextPageCursor != this.PreviousPageCursor
          ? this.fetchActivityList()
          : "";
      }
    },
    isUserAdminOrCAM() {
      if (
        this.userGroups.includes(UserGroup.EPR_ADMIN) ||
        this.userGroups.includes(UserGroup.CUSTOMER_ACCOUNT_MANAGER)
      ) {
        return true;
      }
      return false;
    },
    openReport(data) {
      // Based on user permission report will open in either edit or view modes
      let isEdit = false;
      if (
        this.userHasPermission(Permission.RTRACKER_REPORT_ASSIGN_ALL) &&
        data.active == true
      ) {
        isEdit = true;
      } else if (
        data.active == true &&
        this.userHasPermission(Permission.RTRACKER_REPORT_CHANGE_OWN) &&
        (data.customer_account_manager_id == this.userId ||
          data.reporting_responsible == this.userId)
      ) {
        isEdit = true;
      } else {
        isEdit = false;
      }

      if (isEdit == true) {
        const route = this.$router.resolve({
          name: "reportingtracker.edit",
          params: { id: data.record_id }
        });
        window.open(route.href, "_blank");
      } else {
        const route = this.$router.resolve({
          name: "reportingtracker.view",
          params: { id: data.record_id }
        });
        window.open(route.href, "_blank");
      }
    },
    prepareActivityData(data) {
      for (const idx in data) {
        const activityData = data[idx];
        activityData["user"] = this.userMap[activityData["responsible"]];
        if (activityData["report_status"] == "Submitted") {
          activityData["isGreen"] = true;
        } else {
          activityData["isGreen"] = false;
        }
        data[idx] = activityData;
      }
      return data;
    },
    fetchActivityList(search = "") {
      this.isLoading = true;
      const activityListObserve = this.dashboardDataService.getActivityList(
        this.defaultView,
        search,
        this.query
      );
      activityListObserve.subscribe(
        response => {
          this.nextPageCursor = response["next"]
            ? "&page=" + response["next"].split("&page=")[1]
            : null;
          this.totalRecords = response.count;
          if (this.defaultVeiwChanged) {
            this.records = [];
            this.defaultVeiwChanged = false;
          }
          this.records.push(...this.prepareActivityData(response.results));
          this.records = this.getUniqueListBy(this.records, "id");
          if (this.nextPageCursor != null) {
            this.enableLoadMore = true;
          } else {
            this.enableLoadMore = false;
          }
          this.isLoading = false;
        },
        e => {
          console.log(e);
          this.isLoading = false;
        }
      );
      return activityListObserve;
    },
    openView(data) {
      // Open reports or customer profile only in view mode
      if (data.model == "Customer") {
        const route = this.$router.resolve({
          name: "customers.view",
          params: { id: data.customer }
        });
        window.open(route.href, "_blank");
      } else if (data.model == "ReportTracker") {
        const route = this.$router.resolve({
          name: "reportingtracker.view",
          params: { id: data.record_id }
        });
        window.open(route.href, "_blank");
      } else if (data.model == "Report") {
        const route = this.$router.resolve({
          name: "customers",
          params: { from_dashboard: data.record_ids }
        });
        window.open(route.href, "_blank");
      } else if (data.model == "CountryStreamResponsible") {
        const route = this.$router.resolve({
          name: "reportingTracker.countryOverview",
          params: {}
        });
        window.open(route.href, "_blank");
      } else {
        alert("No navigation identified yet");
      }
    },
    viewConfirm(customer, user, fromDate, toDate) {
      let query = "";
      if (customer != null || customer != undefined) {
        query += "customer=" + customer + "&";
      }
      if (user != null || user != undefined) {
        query += "user=" + user + "&";
      }
      if (fromDate != null || fromDate != undefined) {
        query += "from_date=" + this.dateFormatterNew(fromDate) + "&";
      }
      if (toDate != null || toDate != undefined) {
        query += "to_date=" + this.dateFormatterNew(toDate) + "&";
      }
      this.fetchActivityList(query);
      this.isRefineModalActive = false;
    },
    filterActivityData() {
      this.isRefineModalActive = true;
    },
    closeRefineModal() {
      this.isRefineModalActive = false;
    }
  }
};
</script>
